module.exports = __webpack_public_path__ + "img/basic-unread.8bee00d0.svg";